import { UseFormReturn } from 'react-hook-form'

import { AvailabilityCalendar } from '@/components/availability-calendar'
import { ImportantNotes } from '@/components/important-notes'
import { AdditionalService } from '@monorepo/functions/src/types/services'

import { BookingFormData, DateRange } from '../../types/booking.types'

interface DateSelectionStepProps {
    form: UseFormReturn<BookingFormData>
    selectedDates: DateRange | null
    checkInTime: string
    checkOutTime: string
    onDatesChange: (dates: { from: Date; to: Date } | null) => void
    onCheckInTimeChange: (time: string) => void
    onCheckOutTimeChange: (time: string) => void
    onServiceChange: (services: AdditionalService[]) => void
    dateError?: string
    isDriverTimeManagedExternally?: boolean
}

export function DateSelectionStep({
    form,
    selectedDates,
    checkInTime,
    checkOutTime,
    onDatesChange,
    onCheckInTimeChange,
    onCheckOutTimeChange,
    onServiceChange,
    dateError,
    isDriverTimeManagedExternally = false,
}: DateSelectionStepProps) {
    const services = form.watch('services')
    const hasTimeError = Boolean(
        dateError &&
            (dateError.includes('hora') ||
                dateError.includes('time') ||
                dateError.includes('selecciona la hora') ||
                dateError.includes('select check-in and check-out times')),
    )

    return (
        <div className='flex flex-col space-y-4'>
            <div className='flex flex-col items-center'>
                <AvailabilityCalendar
                    selectedDates={selectedDates}
                    checkInTime={checkInTime}
                    checkOutTime={checkOutTime}
                    onDatesChange={onDatesChange}
                    onCheckInTimeChange={onCheckInTimeChange}
                    onCheckOutTimeChange={onCheckOutTimeChange}
                    onServiceChange={onServiceChange}
                    services={services}
                    showTimeErrors={hasTimeError}
                    isDriverTimeManagedExternally={isDriverTimeManagedExternally}
                />
                <div className='mt-6 w-full max-w-2xl'>
                    <ImportantNotes />
                </div>
            </div>
        </div>
    )
}
